import { div } from "elmtree";
import { VoxelList, } from "../../Components/VoxelList/VoxelList";
import { PlayerActions } from "../../../player/PlayerActions";
import { VoxelPickData } from "./VoxelPickData";
import { UISystem } from "../../../system/ui/UISystem";
const [element, setState] = VoxelList();
const items = [];
const getImg = (input) => {
    return `assets/textures/${input}/default.png`;
};
for (const voxel of VoxelPickData) {
    if (voxel.debug)
        continue;
    items.push({
        id: voxel.id,
        image: voxel.texture ? getImg(voxel.texture) : getImg(voxel.id),
        onClick(id) {
            PlayerActions.setCurrentVoxel(id);
        },
    });
}
export function VoxelScreen() {
    UISystem.appScreen.screens.add([
        {
            id: "voxels",
            getElements: () => div("voxels-container", [element]),
            async afterRender() {
                setState({
                    activeItem: PlayerActions._data.voxel,
                    items: items,
                });
            },
        },
    ]);
}
